/* tslint:disable */
import {
  PlayerNotification
} from '../index';

declare var Object: any;
export interface NotificationInterface {
  "name": string;
  "description"?: string;
  "id"?: any;
  "createdAt": Date;
  "updatedAt": Date;
  playerNotification?: PlayerNotification[];
}

export class Notification implements NotificationInterface {
  "name": string;
  "description": string;
  "id": any;
  "createdAt": Date;
  "updatedAt": Date;
  playerNotification: PlayerNotification[];
  constructor(data?: NotificationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Notification`.
   */
  public static getModelName() {
    return "Notification";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Notification for dynamic purposes.
  **/
  public static factory(data: NotificationInterface): Notification{
    return new Notification(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Notification',
      plural: 'notifications',
      path: 'notifications',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        playerNotification: {
          name: 'playerNotification',
          type: 'PlayerNotification[]',
          model: 'PlayerNotification',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'notificationId'
        },
      }
    }
  }
}
